import { CSSProperties, ReactNode } from 'react'
import { useNavigate } from '../hooks'
import { NavigateFunction } from '../types'

export interface LinkProps {
  to: Parameters<NavigateFunction>[0]
  replace?: boolean
  absolute?: boolean
  data?: any
  style?: CSSProperties
  className?: string
  children: ReactNode
}
export function Link({
  to,
  replace = false,
  absolute = false,
  data,
  style,
  className,
  children,
}: LinkProps) {
  const navigate = useNavigate()

  return (
    <div
      className={className}
      style={{ cursor: 'pointer', ...style }}
      onClick={() => navigate(to, { replace, data, absolute })}
    >
      {children}
    </div>
  )
}
